import { render } from "./industry-settings.vue?vue&type=template&id=711dbd10"
import script from "./industry-settings.vue?vue&type=script&lang=js"
export * from "./industry-settings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__